import { render, staticRenderFns } from "./DesktopNav.vue?vue&type=template&id=23d1c004&scoped=true&"
import script from "./DesktopNav.vue?vue&type=script&lang=ts&"
export * from "./DesktopNav.vue?vue&type=script&lang=ts&"
import style0 from "./DesktopNav.vue?vue&type=style&index=0&id=23d1c004&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d1c004",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VFadeTransition,VIcon})
